import styled from 'styled-components'

export const Copyright = styled.div`
  font-size: ${({ theme }) => theme.fontSizes.xxsmall};
  margin: ${({ theme }) => theme.spacer(1)} 0;
  text-align: center;
  color: ${({ theme }) => theme.colors.gray500};
`
